/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=122804535
export const first_recharge_homopage = createAsyncThunk(
  'firstCharge/first_recharge_homepage',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/misc/first_recharge_homepage',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
export const getProductsList = createAsyncThunk(
  'firstCharge/getProductsList',
  async (param: any = {}, store: any) => {
    const {
      base: {payPrice},
    } = store.getState().Animal_Wren
    // const resp = await http.post('/live/pay/get_products_list', {
    const resp = await http.post(
      '/live/pay/get_first_recharge_products_list',
      {
        ...store.getState().env.deviceinfo,
        ...param,
        before_recharged: 1,
        price: (payPrice * 100).toString(),
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export const getRechargeBonus = createAsyncThunk(
  'firstCharge/getRechargeBonus',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/activity/recharge_bonus',
      {
        ...store.getState().env.deviceinfo,
        mid: store.getState().env.deviceinfo.h_m,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
export const createRechargeOrderV2 = createAsyncThunk(
  'firstCharge/createRechargeOrderV2',
  async (
    params: {
      product_id: string
      pay_method_id: number
      from: string
      code: number
      source: string
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/pay/create_order_h5_v2',
      {
        ...store.getState().env.deviceinfo,
        mid: store.getState().env.deviceinfo.h_m,
        ...params,
      },
      {
        xcHideLog: true,
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
export interface RedirectInfo {
  redirect_url: string
  redirect_param: {[key: string]: string}
  redirect_method: 'get' | 'post'
}
interface ThirdPartyListItem {
  pay_method_id: number
  name: string
  img: string
  product: {
    product_id: string
    price: number
    coins: number
    currency: string
  }
}
const initialState: any = {}
const initData = {
  base: {
    payPrice: '',
  },
  home: {
    version: 'v1',
    count_down: 0,
    list: [],
    buyer_list: [],
  },
  wallet: {
    official_product_id: '',
    huawei_product_id: '',
    countries: [],
    default_country: {
      code: 0,
      name: '',
    },
  },
}

export function useFirstCharge() {
  return useSelector((store) => store.Animal_Wren)
}

export const FirstChargeSlice = createSlice({
  name: 'Animal_Wren',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    updatePayPrice: (state, action: PayloadAction<string>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          payPrice: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(first_recharge_homopage.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {home: data})
    })
    builder.addCase(first_recharge_homopage.rejected, (state, action) => {})
    builder.addCase(getProductsList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {wallet: data})
    })
  },
})

export default FirstChargeSlice.reducer
export const FirstChargeActions = FirstChargeSlice.actions
